<template>
  <label
    class="c-toggle-switch"
    :class="{
      'c-toggle-switch--active': isActive,
      'c-toggle-switch--disabled': disabled,
    }"
    :for="`${name}_switch`"
  >
    <span v-if="label">{{ label }}</span>
    <input
      :id="`${name}_switch`"
      v-model="checkedValue"
      class="c-toggle-switch__input"
      type="checkbox"
      role="switch"
      :disabled="disabled"
    />
    <div class="c-toggle-switch__switch">
      <span class="c-toggle-switch__handler">
        <svg
          v-if="disabled"
          class="c-toggle-switch__icon"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 20 22"
        >
          <defs />
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M7.2 3.2A4 4 0 0114 6v3H6V6c0-1 .4-2 1.2-2.8zM4 9V6a6 6 0 1112 0v3h1a3 3 0 013 3v7a3 3 0 01-3 3H3a3 3 0 01-3-3v-7a3 3 0 013-3h1zm6 4a2.5 2.5 0 100 5 2.5 2.5 0 000-5z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
    </div>
  </label>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentState: this.value,
    }
  },
  computed: {
    isActive() {
      return this.currentState
    },
    checkedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        if (this.disabled) {
          return
        }
        this.currentState = newValue
        this.$emit('input', newValue)
      },
    },
  },
  watch: {
    value() {
      this.currentState = Boolean(this.value)
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '../../../../sass/_www/variables.global.styl'

.c-toggle-switch
  display flex
  user-select none
  cursor pointer

  &--disabled
    cursor not-allowed

  &__input
    opacity 0
    position absolute
    width 1px
    height 1px

  &__switch
    position relative
    display inline-block
    height 28px
    border-radius 16px
    width 48px
    background rgba(72, 72, 72, 0.2)
    transition background 0.15s linear

  &__handler
    background #fff
    position absolute
    display flex
    align-items center
    justify-content center
    height 20px
    width 20px
    border-radius 50%
    left 4px
    top 4px
    transform translateX(0)
    transition transform 0.15s linear

  &__handler &__icon
    color rgba(72, 72, 72, 0.3)
    width 12px
    height 12px

  &--active &__handler &__icon
    color rgb(238, 189, 101)

  &--active &__switch
    background rgb(238, 189, 101)

  &--active &__handler
    transform translateX(48px - 28px)

  &--active &__handler
    background #fff

  @media (max-width $base-breakpoint-small)
    &__switch
      height 24px
      width 42px
      border-radius 12px
    &__handler
      height 16px
      width 16px
      left 4px
    &--active &__handler
      transform translateX(42px - 24px)
    &__icon
      width 10px !important
      height 10px !important
</style>
